import React,{useState,useEffect} from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import FormControl from '@material-ui/core/FormControl';
import Ajax from './Ajax';
import {Inc,Play,EventParam} from "./Inc";
import {Styles} from './Styles';
import {Tools} from './Tools';
import Loading from './Loading';
import FourMeters from './FourMeters';
import Parameter from './Parameter';

interface Props {
    uid: string,
    play:Play,
    param:EventParam,
    close(play:Play):void,
}

interface State {
    word1: string,
    word2: string,
}

let selectedIndex = 0;

const EventWrite = (props:Props)=> {
    const classes = Styles.base();
    const [states,setStates] = useState({
        newPlay: Inc.defaultPlay(),
        selected: false,
        finished: false,
        isLoading: false,
        word1: "",
        word2: "",
    })
    const change = (name: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
        let word = event.target.value;
        word = word.substr(0,12).trim();
        setStates({ ...states, [name]: word });
    };    
    const write = (e: React.MouseEvent<HTMLElement>) =>{
        if( e.currentTarget.dataset.index ){
            selectedIndex = parseInt(e.currentTarget.dataset.index);
        } else {
            selectedIndex = 0;
        }
        setStates({...states,isLoading:true});
        Ajax.send("event/send",{play_id:props.play.id,selected:selectedIndex,talk_id:props.param.talk_id,word1:states.word1,word2:states.word2},(res:any)=>{
            if( res.ok ){
                setStates({...states,newPlay:res.play,isLoading:false,selected:true});
            }
        })
    }
    const auto = ()=>{
        Ajax.send("word/auto",{talk_id:props.param.talk_id},(res:any)=>{
            setStates({...states,isLoading:true});
            if( res.ok ){
                setStates({...states,isLoading:false,word1:res.word1,word2:res.word2});
            }
        });
    }
    const close = ()=>{
        props.close(states.newPlay);
    }
    const finish = ()=>{
        setStates({...states,finished:true});
    }

    useEffect( ()=>{
        selectedIndex = 0;
    },[]);

    if( states.selected ){
        return (
            <div id="event_write" style={{overflowY:"auto",height:"100%"}}>
                <div style={{height:"100%",minHeight:"480px",boxSizing:"border-box",paddingBottom:"8em"}}>
                <div className={classes.room}>
                {selectedIndex===0 &&
                    <span>鉛筆を机に戻した<br/>こんなことをしている場合じゃない</span>
                }
                {selectedIndex===1 &&
                    <span>空欄をすべて埋めた<br/>以前にもこんなことがあったような、記憶の輪郭をなぞる冷たい指先を感じてゾッとした</span>
                }
                </div>
                <div className={classes.meters}>
                    <FourMeters stWater={props.play.water} stMagenta={props.play.magenta} stCyan={props.play.cyan} stYellow={props.play.yellow} enWater={states.newPlay.water} enMagenta={states.newPlay.magenta} enCyan={states.newPlay.cyan} enYellow={states.newPlay.yellow} finish={finish}/>
                </div>
                {states.finished &&
                <div className={classes.modalBottom}>
                    <FormControl fullWidth={true} className={classes.formControl}>
                        <Button variant="outlined" color="primary" onClick={close}>{Tools.voice()}</Button>
                    </FormControl>
                </div>
                }
                </div>
            </div>
        );    
    }

    let color1:"primary"|"secondary" = "secondary";
    let color2:"primary"|"secondary" = "secondary";
    if( states.word1.length===12 ){
        color1 = "primary";
    }
    if( states.word2.length===12 ){
        color2 = "primary";
    }

    return (
        <div id="event_write" style={{overflowY:"auto",height:"100%",position:"absolute",top:"0",left:"0",width:"100%"}}>
            <div style={{minHeight:"480px",height:"100%",boxSizing:"border-box",position:"relative"}}>
                <div style={{padding:"1em",paddingTop:"4em"}}>
                    <div className={classes.room}>
                    ベッドと机のある部屋だ<br/>
                    机には白紙の答案が置かれている<br/>
                    {props.param.selected>=0 &&
                        <div>
                            {Tools.lover(props.play,props.param)}が回答しようとして諦めたかのように鉛筆が放り出されていた
                        </div>
                    }
                    </div>

                    <div className={classes.messageBoard}>
                        <Typography variant="subtitle2">■文章を完成させなさい</Typography>
                        <span style={{marginRight:"0.5em"}}>{props.param.talks[0]}</span>
                        <span style={{marginRight:"0.5em"}}><Badge badgeContent={12-states.word1.length} color={color1}><input type="text" autoComplete="off" onChange={change("word1")} placeholder="12文字以内" value={states.word1}/></Badge></span>
                        <span style={{marginRight:"0.5em"}}>{props.param.talks[1]}</span>
                        <span style={{marginRight:"0.5em"}}><Badge badgeContent={12-states.word2.length} color={color2}><input type="text" autoComplete="off" onChange={change("word2")} placeholder="12文字以内" value={states.word2}/></Badge></span>
                        <span>{props.param.talks[2]}</span>                
                    </div>
                    <div style={{textAlign:"center",marginTop:"0.5em"}}>
                        <Button variant="contained" color="primary" size="small" onClick={auto}>自動</Button>
                    </div>
                </div>
                <div className={classes.modalBottomAbs}>
                    <FormControl fullWidth={true} className={classes.formControl}>
                        <Button variant="contained" color="primary" onClick={write} data-index={1} style={{marginBottom:"0.2em"}} disabled={states.word1==="" || states.word2===""}>回答する</Button>
                        <Button variant="outlined" color="primary" onClick={write} data-index={0} style={{marginBottom:"0.2em"}}>無視する</Button>
                    </FormControl>
                    <Parameter play={props.play}/>
                </div>
            </div>
            <Loading isLoading={states.isLoading}/>
        </div>
    );
}

export default EventWrite;
